import { marked } from "marked";

import { logError } from "../../../utils/error";

const isDescriptionHeading = (token: any): boolean => {
  return token.type === "heading" &&
         token.depth === 2 &&
         token.text.toLowerCase().trim() === "description";
};

const isOtherHeading = (token: any): boolean => {
  return token.type === "heading" && token.depth === 2;
};

/**
 * Extracts the title (H1 heading) from markdown content
 */
export const extractTitleFromMarkdown = (markdownContent: string): string | null => {
  if (!markdownContent?.trim()) {
    return null;
  }

  try {
    const tokens = marked.lexer(markdownContent);

    for (const token of tokens) {
      if (token.type === "heading" && token.depth === 1) {
        return token.text.trim() || null;
      }
    }

    return null;
  } catch (error) {
    logError("Error parsing markdown for title", error);
    return null;
  }
};

export const extractDescriptionFromMarkdown = (markdownContent: string): string | null => {
  if (!markdownContent?.trim()) {
    return null;
  }

  try {
    const tokens = marked.lexer(markdownContent);
    let foundDescriptionHeading = false;

    for (const token of tokens) {
      if (isDescriptionHeading(token)) {
        foundDescriptionHeading = true;
        continue;
      }

      if (foundDescriptionHeading && isOtherHeading(token)) {
        break;
      }

      if (foundDescriptionHeading && token.type === "paragraph") {
        return token.text.trim() || null;
      }
    }

    return null;
  } catch (error) {
    logError("Error parsing markdown", error);
    return null;
  }
};
